import React, { Component } from "react";
import { Row, Col, Space, Image } from "antd";
import { Link } from "react-router-dom";
import "../../App.css";

export default class Phantom extends Component {
  render() {
    return (
      <>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row justify="center">
              <Col span={24} className="paddLR10">
                <Link className="breadCrumbText link" to="/home">
                  Home
                </Link>
                &nbsp;&gt;&nbsp;
                <Link className="breadCrumbText link" to="/Illustration">
                  Illustration
                </Link>
              </Col>
              <Col span={24} className="f4EM fAN color110 paddLR10 paddTop60">
                Phantom 309
              </Col>
              <Col span={24} className="paddTop60"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row className="bgColorGray" justify="center">
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row>
              <Col span={24} className="paddTop40 paddLR10">
                <Space direction="vertical" size="large">
                  <Image
                    alt="Phantom 0 Image"
                    className="img100"
                    src={`${process.env.PUBLIC_URL}/images/jpg/Phantom.jpg`}
                    loading="lazy"
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Phantom_blur.jpg`}
                        preview={false}
                        className="img100"
                      />
                    }
                  />
                  <div className="f2EM color110 fAN paddTop40 colCenter">
                    Layout
                  </div>
                  <div className="paddTop10"></div>
                  <Image
                    alt="Phantom 0 Image"
                    className="img100"
                    src={`${process.env.PUBLIC_URL}/images/jpg/Phantom_1.jpg`}
                    loading="lazy"
                    preview={false}
                    placeholder={
                      <Image
                        src={`${process.env.PUBLIC_URL}/images/jpg/Phantom_1_blur.jpg`}
                        preview={false}
                        className="img100"
                      />
                    }
                  />
                </Space>
              </Col>
              <Col span={24} className="paddTop40"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row>
          <Col className="rH100"></Col>
        </Row>
      </>
    );
  }
}
